"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledSystem = require("styled-system");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../utils");

var _Box = _interopRequireDefault(require("../Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  ", ";\n  ", ";\n  background-size: cover;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AvatarStructure = function AvatarStructure(props) {
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], _extends({
    color: props.color,
    avatarSize: props.avatarSize,
    initials: props.initials,
    name: props.name,
    shape: props.shape
  }, props), props.type === 'text' && /*#__PURE__*/_react["default"].createElement("svg", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "100",
    height: "100"
  }), /*#__PURE__*/_react["default"].createElement("text", {
    x: "50%",
    y: "50%",
    dy: "3%",
    alignmentBaseline: "central",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fill: "white",
    fontFamily: "sans-serif",
    fontWeight: "600",
    fontSize: "40"
  }, props.name && props.name.slice(0, 2) || props.initials))), props.type === 'icon' && /*#__PURE__*/_react["default"].createElement("svg", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "100",
    height: "100"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M30.224 36.982C30.224 25.964 39.319 17 50.5 17c11.18 0 20.276 8.964 20.276 19.982v4.996c0 11.019-9.095 19.983-20.276 19.983-11.18 0-20.276-8.964-20.276-19.983v-4.996zM84 98.198c0 .924-.75 1.67-1.675 1.67h-63.65c-.925 0-1.675-.746-1.675-1.67v-3.34c0-14.737 12.023-26.726 26.8-26.726h13.4c14.777 0 26.8 11.99 26.8 26.725v3.341z",
    fill: "white",
    fillRule: "nonzero"
  }))));
};

var avatarSize = (0, _styledSystem.variant)({
  key: 'avatarSizes',
  prop: 'avatarSize'
});
var Avatar = (0, _styledComponents["default"])(AvatarStructure)(_templateObject(), avatarSize, _utils.shape);

function getRandomColor() {
  var colorValues = ['neutral', 'action', 'success', 'danger', 'warning'];
  return colorValues[Math.floor(Math.random() * colorValues.length)];
}

Avatar.defaultProps = {
  avatarSize: 'medium',
  display: 'inline-flex',
  color: getRandomColor(),
  type: 'text',
  initials: 'Aa',
  shape: 'circle',
  flex: 'none'
};
Avatar.propTypes = {
  initials: _propTypes["default"].string,
  name: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['text', 'icon']),
  shape: _propTypes["default"].oneOf(['square', 'rounded', 'circle']),
  avatarSize: _propTypes["default"].oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge'])
};
var _default = Avatar;
exports["default"] = _default;